import { Radio } from 'antd';

// Internally used component to format choices
import ChoiceFormatter from '../ChoiceFormatter/ChoiceFormatter';

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

const childLib = {
    default: Radio,
    button: RadioButton
};

const HVRadio = ({ child = 'default', ...props }) => {
    return (
        <ChoiceFormatter
            parent={RadioGroup}
            child={childLib[child]}
            {...props}
        />
    );
};

export default HVRadio;
